document.addEventListener("DOMContentLoaded", function () {

const scrollDock = document.getElementById("scroll-dock");
const largeLogo = document.getElementById("large_logo");
const smLogo = document.getElementById("small_logo");
const subMenus = document.querySelectorAll('.menu-sub-group')
const menuLinks = document.querySelectorAll('.secondary-menu-item')

function toggleClassOnScrollAndResize() {
  const scrollPosition = window.scrollY;
  const screenWidth = window.innerWidth;

  // Check if the screen width is larger than 767px
  if (screenWidth > 992) {
    if (scrollPosition >= 150) {
      if (!scrollDock.classList.contains("toggle-dock-top")) {
        scrollDock.classList.add("toggle-dock-top");
        largeLogo.classList.add("hidden");
        smLogo.classList.remove("hidden");
        subMenus.forEach(function(i){
          // i.classList.add('top-[113px]');
          // i.classList.remove('top-[39px]');
        })    
        menuLinks.forEach(function(i){
          i.classList.add('pb-[24px]');
          i.classList.remove('pb-[68px]');
        })     
      }
    } else {
      if (scrollDock.classList.contains("toggle-dock-top")) {
        scrollDock.classList.remove("toggle-dock-top");
        largeLogo.classList.remove("hidden");
        smLogo.classList.add("hidden");
        subMenus.forEach(function(i){
          // i.classList.add('top-[39px]');
          // i.classList.remove('top-[113px]');
        })
        menuLinks.forEach(function(i){
          i.classList.add('pb-[68px]');
          i.classList.remove('pb-[24px]');
        })
      }
    }
  } else {
    // Remove the class if the screen width is 767px or smaller
    if (scrollDock.classList.contains("toggle-dock-top")) {
      scrollDock.classList.remove("toggle-dock-top");
      largeLogo.classList.remove("hidden");
      smLogo.classList.add("hidden");
      subMenus.forEach(function(i){
        i.classList.add('top-[39px]');
        i.classList.remove('top-[113px]')
      })
      menuLinks.forEach(function(i){
        i.classList.add('pb-[68px]');
        i.classList.remove('pb-[24px]');
      })
    }
  }
}

// Add a scroll event listener to the window
window.addEventListener("scroll", toggleClassOnScrollAndResize);

// Add a resize event listener to handle changes in screen width
window.addEventListener("resize", toggleClassOnScrollAndResize);

// Call the function initially to set the class based on the initial screen size
toggleClassOnScrollAndResize();

});